import { Tab } from '@mairistem/composants';
import { getMenuItem } from '@mairistem/finances-utils';
import React from 'react';
import type OutilModalProps from '../../../../interfaces/simulation/outilModalProps';
import ResteARealiser from './ResteARealiser';
import ResultatReporte from './ResultatReporte';
import './RecopieReportMenu.css';

const RecopieReportMenu = ({
	onValidate,
	simulation,
}: Pick<OutilModalProps, 'onValidate' | 'simulation'>) => {
	const PANES = [
		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'Résultats reportés',
					'data-testid': 'resultatReporteMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ResultatReporte onValidate={onValidate} simulation={simulation} />
				</Tab.Pane>
			),
		},
		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'Restes à réaliser',
					'data-testid': 'resteARealiserMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ResteARealiser onValidate={onValidate} simulation={simulation} />
				</Tab.Pane>
			),
		},
	];

	return (
		<Tab
			className="recopieReportMenu"
			menu={{
				pointing: true,
				secondary: true,
				vertical: true,
			}}
			panes={PANES}
		/>
	);
};

export default RecopieReportMenu;
